import * as React from 'react';
import { useSelector } from 'react-redux';

import { details } from './content';
import { DealPriceSection } from '../../components/DealPriceSection';
import { trackNavigateToDealForm } from '../../utils/analytics';
import { selectDealFormUrl } from '../../selectors/promoInfo/selectDealFormUrl';
import { useApplicationContext } from '../../utils/applicationContext';
import { IPriceData } from '../../types/promoInfo/priceData';
import { makeFileNotCacheable } from '../../utils/makeFileNotCacheable';

export const PRICE_LIST_URL = makeFileNotCacheable(
  'https://cdn.cian.site/frontend/e2e-form-assets/documents/e2e_deal_price_list.pdf',
);
export const FALLBACK_PRICE_DATA = {
  initialPrice: '3 900 ₽',
};

/**
 * Секция "Сколько стоит Циан.Сделка".
 */
export const DealPriceSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dealFormUrl = useSelector(selectDealFormUrl);
  const { config } = useApplicationContext();

  const priceData =
    config.get<IPriceData>('deal-sale-promo-frontend.priceData') || /* istanbul ignore next */ FALLBACK_PRICE_DATA;

  const onCreateDealButtonClick = () => {
    trackNavigateToDealForm('price');
  };

  return (
    <DealPriceSection
      dealFormUrl={dealFormUrl}
      priceData={priceData}
      priceListUrl={PRICE_LIST_URL}
      details={details}
      onCreateDealButtonClick={onCreateDealButtonClick}
    />
  );
};
